import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from '../routeGenerator';

export const waterRouteDefinitions: RouteDefinition[] = [
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_WATER.USAGE} />
    ),
    name: 'Aggregated Usage',
    path: NESTED_ROUTES.INTERVAL_DATA_WATER.USAGE,
    description: 'Analyze water usage by selectable time periods',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_WATER.MAP} />
    ),
    name: 'Usage Map',
    path: NESTED_ROUTES.INTERVAL_DATA_WATER.MAP,
    description: 'Review water usage by site location',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_WATER.HEATMAP} />
    ),
    name: 'Water Heatmap',
    path: NESTED_ROUTES.INTERVAL_DATA_WATER.HEATMAP,
    description: 'Analyze water usage over time',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.INTERVAL_DATA_WATER.POINTS} />
    ),
    name: 'All Water Points',
    path: NESTED_ROUTES.INTERVAL_DATA_WATER.POINTS,
    description: 'Analyze trends for all available water points',
  },
];
